import { createContext, useContext } from "react";
import type { MediaInterface } from "~/components/media/Context";

export const MediaContext = createContext<MediaInterface>({} as MediaInterface);

export function useMedia() {
	const context = useContext(MediaContext);

	if (context === null) throw new Error("Media context is not available");

	return context;
}
